export default __webpack_public_path__ + "static/media/logotipo-white.d019600f.png";